/**
 * This is interveners-details script.js file
 */

import ActionsDetail from '@/components/actions-detail';
import Bastanteo from '@/views/shared/bastanteo';
import ElementList from '@/components/element-list';
// import IntervenerAdd from '@/views/intervener-add';
import IntervenerAux from '@/views/interveners-details/intervener-aux';
import IntervenerInfoBox from '@/views/interveners-details/intervener-info-box';
import IntervenerParticipantAccounts from '@/views/interveners-details/intervener-participant-accounts';
import IntervenersDetailsInfo from '@/views/interveners-details/interveners-details-info';
import permissionUser from '@/inheritance/permission-user';
import RelatedDocumentation from '@/views/shared/related-documentation';
import RelatedHistoric from '@/views/shared/related-historic';
import RelatedIssues from '@/views/shared/related-issues';
import RelatedOperations from '@/views/shared/related-operations';

export default {
    name: 'IntervenerDetail',

    extends: permissionUser,

    props: {
        id: {
            type: String,
            required: false
        }
    },
    components: {
        ActionsDetail,
        Bastanteo,
        ElementList,
        // IntervenerAdd,
        IntervenerAux,
        IntervenerInfoBox,
        IntervenerParticipantAccounts,
        IntervenersDetailsInfo,
        RelatedDocumentation,
        RelatedHistoric,
        RelatedOperations,
        RelatedIssues
    },
    /**
     * @override
     */
    data() {
        return {
            intervener: null,
            saving: false,
            savingTitle: 'Guardar cambios',
            tabs: ['Detalles', 'Relacionado', 'Casos', 'Auxiliar', 'Bastanteo'],
            intervenerIssues: [],
            intervenerIssuesResolved: [],
            intervenerIssuesNotResolved: [],
            pendingIntervenerIssues: 0,
            tabIndexSelected: 0,
            componentKey: 0,
            numberItemsNotValidated: 0,
            intervenerRisk: [],
        };
    },
    /**
     * @override
     */
    mounted() {
        this.$root.$off('refresh_intervener', this.fetchData);
        this.$root.$on('refresh_intervener', this.fetchData);
        /**
         * TOTAL de items no validados
         * Emit lanzado desde el componente BastanteoGroup
         */
        this.$root.$off('emit_items_not_validated', this.updateItemsNotValidated);
        this.$root.$on('emit_items_not_validated', this.updateItemsNotValidated);
    },
    /**
     * @override
     */
    beforeDestroy() {
        this.$root.$off('refresh_intervener', this.fetchData);
        this.$root.$off('emit_items_not_validated', this.updateItemsNotValidated);
    },

    /**
     * Comprueba que la URL cambia y obtiene los datos
     */
    watch: {
        $route: {
            /**
             * Comprobamos con un watch si la URL ha cambiado y obtenemos los datos
             */
            handler() {
                this.intervener = null;
                this.saving = false;
                this.savingTitle = 'Guardar cambios';
                if (this.$route.name !== 'interveners_add') {
                    this.fetchData();
                }
                if (this.$route.query && this.$route.query.tab && this.$route.query.tab === 'issues') {
                    this.setTabIndexSelected(2);
                }
                if (this.$route.query && this.$route.query.tab && this.$route.query.tab === 'bastanteo') {
                    this.setTabIndexSelected(4);
                }
            },
            immediate: true
        }
    },

    methods: {
        /**
         * Indicamos el tab activo
         * @param {Number} index Indice del tab activo
         */
        setTabIndexSelected(index) {
            this.tabIndexSelected = index;
            localStorage.setItem(`tabs_intervener_${this.uuid_intervener}`, index);
        },

        /**
         * Obtenemos la información del interviniente
         */
        fetchData() {
            this.numberItemsNotValidated = 0;
            this.uuid_intervener = this.id || this.$route.params.uuid;
            this.tabIndexSelected = +localStorage.getItem(`tabs_intervener_${this.uuid_intervener}`);
            this.loadIntervener(this.uuid_intervener);
            this.loadIntervenerIssues(this.uuid_intervener);
            if( this.amlAllowed ) this.loadIntervenerAml(this.uuid_intervener);
        },       
        /**
         * Obtenemos el interviniente desde el servicio
         * @param {String} uuid ID del interviniente
         */
        loadIntervener(uuid) {
            const cfg = {
                params: {
                    // '$expand': 'users,permission_set'
                }
            };
            this.$intervenersService.getIntervenersByUUIId(uuid, cfg).then(res => {
                this.intervener = res.data.intervener;
                this.intervener.uuid = uuid;
                if (this.intervener.contacts.contact_draft_data) {
                    this.numberItemsNotValidated++;
                }
                if (this.intervener.personal_data.personal_draft_data) {
                    this.numberItemsNotValidated++;
                }
                if (this.intervener.fiscal_address.fiscal_draft_data) {
                    this.numberItemsNotValidated++;
                }
                this.componentKey += 1;
            });
        },
        /**
         * Obtenemos obtenemos las incidencias del interviniente desde el servicio
         * @param {String} uuid ID del interviniente
         */
        loadIntervenerIssues(uuid) {
            this.$intervenersService.getIntervenerIssues(uuid).then(res => {
                this.intervenerIssues = res.data.interveners_issues || [];
                this.intervenerIssues = this.intervenerIssues.filter(item => item.uuid);
                this.intervenerIssuesResolved = this.intervenerIssues.filter(item => item.status === 'RESOLVED');
                this.intervenerIssuesNotResolved = this.intervenerIssues.filter(item => item.status !== 'RESOLVED');
                this.pendingIntervenerIssues = this.intervenerIssuesNotResolved.length;
            });
        },
        /**
         * Guardamos la información del interviniente
         * Marco como 'undefined' los objetos obtenidos por $expand
         * @param {Event} e FormEvent
         */
        onSubmit(e) {
            e.preventDefault();
            this.saving = true;
            this.savingTitle = 'Guardando...';
            this.$intervenersService.update(this.intervener).then(response => {
                if (response.result && response.result.http_code !== 200) {
                    this.saving = false;
                    this.savingTitle = 'Guardar cambios';
                    this.$toast.error(`Error ${response.result.http_code}`, `${response.result.info}`);
                } else {
                    // Actualizar pestaña
                    this.updateItemMenu(response);
                }
            });
        },
        /**
         * Actualizamos la pestaña actual del menú con el nuevo nombre
         * @param {Object} res Resultado obtenido de la modificación para mostrar en el toast
         */
        updateItemMenu(res) {
            if (this.$route.meta && this.$route.meta.isView) {
                this.$store.dispatch('yuriMenuStore/updateSubItemName', this.intervener.given_name).then(() => {
                    this.savingTitle = '¡Guardado!';
                    const query = Object.assign({}, this.$route.query);
                    delete query.edit;
                    this.$router.replace({ query }).then(() => this.$toast.success(`Success`, `${res.result.info}`));
                });
            } else {
                // Pestaña menú principal
                this.$store.dispatch('yuriMenuStore/updateItemName', this.intervener.key_name).then(() => {
                    this.savingTitle = '¡Guardado!';
                    this.$router.go(-1);
                    this.$toast.success(`Success`, `${res.result.info}`);
                });
            }
        },

        /**
         * Update intervener information on status update
         */
        intervenerStatusHasChanged() {
            this.fetchData();
        },

        /**
         * ACTUALIZA ITEMS NO VALIDADOS
         * Emit lanzado desde el componente BastanteoItem
         *
         * @param {Object} items: items no validados
         *
         */
        updateItemsNotValidated(items) {
            this.numberItemsNotValidated = items.length;
        },
        
        async loadIntervenerAml(uuid) {
            try {
              const res = await this.$intervenersService.getIntervenerAml(uuid);
              const amlData = res.data;
          
              if (amlData && ['high', 'medium'].includes(amlData.risk)) {
                this.intervenerRisk = [amlData];
              } else {
                this.intervenerRisk = [];
              }
            } catch (error) {
              console.error('Error fetching risk info', error);
            }
        },          
    },
    computed: {
        /**
         * Indica si estamos editando un usuario o no
         * @return {Boolean} Editable true/false
         */
        editable() {
            if (this.actionObject('INTERVENERS', 'edit')) {
                return this.$route.query && (this.$route.query.edit === true || this.$route.query.edit === 'true')
                    ? true
                    : false;
            }
            return false;
        },

        amlAllowed() {
            return this.$store.getters['configVarsStore/getAllowAML'];
        },
    }
};
